import { API_ROOT } from '../../config/config'
import { doDownload, doGet, doPost, doPostDownload, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getPerposalWordFile = async (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/proposal/evaluation/word`

  return doDownload(url)
}

export const sendAiEvaluationByFile = (id, request) => {
  const url = `${API_ROOT}/proposal/evaluation/send/${id}`
  return doPutFiles(url, request)
}

export const sendAiEvaluation = (id, request) => {
  const url = `${API_ROOT}/proposal/evaluation/send/${id}`
  return doPost(url, request)
}

export const getAiEvaluationResult = (projectId, id, projectCode) => {
  const url = `${API_ROOT}/proposal/evaluation/get-result?projectId=${projectId || ''}&id=${id || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const checkAiEvaluationStatus = (id) => {
  const url = `${API_ROOT}/proposal/evaluation/check?id=${id || ''}`
  return doGet(url)
}

export const getAiEvaluationReportPage = (pageNum, pageSize) => {
  const url = `${API_ROOT}/proposal/evaluation/report?pageNum=${pageNum || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchAiEvaluationReport = (request) => {
  const url = `${API_ROOT}/proposal/evaluation/report`
  return doPost(url, request)
}

export const exportAiEvaluationReport = (request) => {
  const url = `${API_ROOT}/proposal/evaluation/report/export`
  return doPostDownload(url, request)
}

export const getAiEvaluationHistory = (projectId, projectCode) => {
  const url = `${API_ROOT}/proposal/evaluation/history?projectId=${projectId || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}
